import request from '@/utils/request'

/**
 * 物业账号管理API（城市运营商端）
 */

// 获取物业账号列表
export function getPropertyAccountList(params) {
  return request({
    url: '/property-accounts',
    method: 'get',
    params
  })
}

// 获取物业账号详情
export function getPropertyAccountDetail(id) {
  return request({
    url: `/property-accounts/${id}`,
    method: 'get'
  })
}

// 创建物业账号（城市运营商创建）
// data包含: accountName, accountType(GROUP/SINGLE), communityId(仅SINGLE类型需要), contactPerson, contactPhone, username, password, status
export function createPropertyAccount(data) {
  return request({
    url: '/property-accounts',
    method: 'post',
    data
  })
}

// 更新物业账号
export function updatePropertyAccount(id, data) {
  return request({
    url: `/property-accounts/${id}`,
    method: 'put',
    data
  })
}

// 删除物业账号
export function deletePropertyAccount(id) {
  return request({
    url: `/property-accounts/${id}`,
    method: 'delete'
  })
}

// 重置物业账号密码
export function resetPropertyAccountPassword(id) {
  return request({
    url: `/property-accounts/${id}/reset-password`,
    method: 'post'
  })
}

// 启用/禁用物业账号
export function togglePropertyAccountStatus(id, status) {
  return request({
    url: `/property-accounts/${id}/status`,
    method: 'put',
    data: { status }
  })
}

// 获取可用小区列表（用于绑定）
export function getAvailableCommunityList(params) {
  return request({
    url: '/communities/available',
    method: 'get',
    params
  })
}

// 检查小区是否已被绑定
export function checkCommunityBinding(communityId) {
  return request({
    url: `/communities/${communityId}/check-binding`,
    method: 'get'
  })
}

// 解绑小区
export function unbindCommunity(accountId) {
  return request({
    url: `/property-accounts/${accountId}/unbind-community`,
    method: 'put'
  })
}

// 获取物业账号统计信息
export function getPropertyAccountStats() {
  return request({
    url: '/property-accounts/stats',
    method: 'get'
  })
}

// 获取当前登录物业账号的绑定小区信息
export function getCurrentPropertyAccountCommunity() {
  return request({
    url: '/property-accounts/current/community',
    method: 'get'
  })
}
